var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 43.75V39.5833C34.1667 37.3732 33.2887 35.2536 31.7259 33.6908C30.1631 32.128 28.0435 31.25 25.8333 31.25H13.3333C11.1232 31.25 9.00358 32.128 7.44078 33.6908C5.87797 35.2536 5 37.3732 5 39.5833V43.75",
    stroke: "#0E0924",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1641 6.5166C35.9511 6.97987 37.5336 8.0234 38.6634 9.4834C39.7932 10.9434 40.4061 12.7372 40.4061 14.5833C40.4061 16.4293 39.7932 18.2231 38.6634 19.6831C37.5336 21.1431 35.9511 22.1867 34.1641 22.6499",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 43.7502V39.5835C46.6627 37.7371 46.0481 35.9434 44.9169 34.4842C43.7857 33.0249 42.2018 31.9826 40.4141 31.521",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 22.9167C24.1857 22.9167 27.9167 19.1857 27.9167 14.5833C27.9167 9.98096 24.1857 6.25 19.5833 6.25C14.981 6.25 11.25 9.98096 11.25 14.5833C11.25 19.1857 14.981 22.9167 19.5833 22.9167Z",
    stroke: "#0E0924",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentLogo);
export default __webpack_public_path__ + "static/media/student_logo.23b4a8133754702fb2d82f116c813570.svg";
export { ForwardRef as ReactComponent };